export const backgroundSizeList = [
  {
    label: 'Default',
    value: '',
  },		
  {
    label: 'Cover',
    value: 'cover',
  },							
  {
    label: 'Contain',
    value: 'contain',
  },
  {
    label: 'Custom',
    value: 'custom',
  },

]

export const backgroundPositionList = [
  {
    label: 'Default',
    value: '',
  },		
  {
    label: 'Center Center',
    value: 'center center',
  },							
  {
    label: 'Center Left',
    value: 'center left',
  },	
  {
    label: 'Center Right',
    value: 'center right'
  },
  {
    label: 'Top Center',
    value: 'top center',
  },							
  {
    label: 'Top Left',
    value: 'top left',
  },	
  {
    label: 'Top Right',
    value: 'top right'
  },
  {
    label: 'Bottom Center',
    value: 'bottom center',
  },							
  {
    label: 'Bottom Left',
    value: 'bottom left',
  },	
  {
    label: 'Bottom Right',
    value: 'bottom right'
  }
]

export const backgroundRepeatList = [
  {
    label: 'Default',
    value: ''
  },
  {
    label: 'No Repeat',
    value: 'no-repeat'
  },
  {
    label: 'Repeat',
    value: 'repeat'
  },
  {
    label: 'Repeat',
    value: 'repeat'
  },
  {
    label: 'Repeat X',
    value: 'repeat-x'
  },
  {
    label: 'Repeat Y',
    value: 'repeat-y'
  }
  
]

export const svgBackgroundList = [
  { 
    label: 'None',
    value: '',
  },
  {
    label: 'Topography',
    value: 'topography',
  },
  
  {
    label: 'Texture',
    value: 'texture',
  },
  {
    label: 'Graph Paper',
    value: 'graph-paper',
  },
  {
    label: 'Bubbles',
    value: 'bubbles',
  },

  {
    label: 'Polka Dots',
    value: 'polka-dots',
  },
  {
    label: 'Leaf',
    value: 'leaf',
  }, 
  {
    label: 'Custom',
    value: 'custom',
  }     

]